<app-dialog-header [title]="'general.api_event_selling_under_alias_salespoint_title'"></app-dialog-header>
<mat-dialog-content>
  <div class="body-2">{{ 'general.api_event_selling_under_alias_salespoint_description' | translate }}</div>
</mat-dialog-content>
<app-dialog-footer [defaultActionName]="'general.api_general_ok'"></app-dialog-footer>
